var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24992 9.91667H10.7499M7.99992 7.16667L7.99992 12.6667M12.5833 17.25H3.41659C2.40406 17.25 1.58325 16.4292 1.58325 15.4167V2.58333C1.58325 1.57081 2.40406 0.75 3.41659 0.75H8.53689C8.78001 0.75 9.01316 0.846577 9.18507 1.01849L14.1481 5.98151C14.32 6.15342 14.4166 6.38658 14.4166 6.6297V15.4167C14.4166 16.4292 13.5958 17.25 12.5833 17.25Z",
    stroke: "#9BA1A8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon3);
export default __webpack_public_path__ + "static/media/menu-icon-3.9b5ae1e41635305ee90d68d75d15a9d9.svg";
export { ForwardRef as ReactComponent };